import { INavigationItem } from '@components/Layouts/Layout/Layout';
import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import { Link } from 'gatsby';
import React, { useContext, useState } from 'react';

import { ChevronLeft, ChevronRight, Cross } from '../Icon/index';
import * as styles from './MobileMenu.module.css';

const SubMenu = ({
	children,
	heading,
	subMenuOpen,
	setSubMenuOpen,
	providedID,
}: {
	children: React.ReactNode;
	heading: string;
	subMenuOpen: number[];
	setSubMenuOpen: (prevState: any) => void;
	providedID: number;
}) => {
	const { variant } = useContext(ThemeContext);

	return (
		<aside
			className={cx(styles.subMenu, styles[variant], {
				[styles.open]: subMenuOpen.includes(providedID),
				[styles.inactive]: subMenuOpen[subMenuOpen.length - 1] !== providedID,
			})}>
			<div className={cx(styles.bounds, styles.scroll)}>
				<nav className={styles.navigation}>
					<ul>
						<li className={styles.item}>
							<button
								onClick={(e) => {
									e.stopPropagation();
									setSubMenuOpen((indexes: number[]) => {
										return subMenuOpen.includes(providedID)
											? subMenuOpen.filter((ID) => ID !== providedID)
											: [...indexes];
									});
								}}
								className={cx(styles.button, styles.heading)}>
								<ChevronLeft className={styles.icon} />
								{heading}
							</button>
						</li>
						{children}
					</ul>
				</nav>
			</div>
		</aside>
	);
};

const MobileMenu = ({
	logo,
	isGroup = false,
	isCampaign = false,
	innotransnav,
	navigation,
	subNavigation,
	careers,
	open,
	setOpen,
}: {
	logo?: React.ReactNode;
	isGroup?: boolean;
	isCampaign?: boolean;
	navigation: INavigationItem[];
	innotransnav: INavigationItem[];
	subNavigation: any;
	careers: boolean;
	open: boolean;
	setOpen: (value: boolean | ((prevVar: boolean) => boolean)) => void;
}) => {
	const { variant } = useContext(ThemeContext);
	let index = 1;
	const [subMenuOpen, setSubMenuOpen] = useState([0]);

	return (
		<aside
			className={cx(styles.aside, styles[variant], {
				[styles.open]: open,
				[styles.inactive]: subMenuOpen[subMenuOpen.length - 1] !== 0,
			})}
			data-id={0}>
			<div className={styles.bounds}>
				<div className={styles.logo}>{logo}</div>
			</div>

			<button
				aria-label="Close menu"
				className={styles.close}
				onClick={(e) => {
					e.stopPropagation();
					setOpen(false);
					setSubMenuOpen([0]);
				}}>
				<Cross />
			</button>

			<div className={cx(styles.bounds, styles.scroll)}>
				{navigation && !isCampaign && (
					<nav className={styles.navigation}>
						<ul className={styles.list}>
							{navigation.map(
								(
									{ to, label, links, subMenu, globalNavigation },
									key: number
								) => {
									if (globalNavigation) return;

									const ID = index;
									if (subMenu) index++;

									return subMenu ? (
										<li className={styles.item} key={key}>
											<button
												onClick={(e) => {
													e.stopPropagation();
													setSubMenuOpen((indexes) =>
														subMenuOpen.includes(ID)
															? indexes
															: [...indexes, ID]
													);
												}}
												className={styles.button}>
												{label}
												<ChevronRight className={styles.icon} />
											</button>

											<SubMenu
												heading={label}
												subMenuOpen={subMenuOpen}
												setSubMenuOpen={setSubMenuOpen}
												providedID={ID}>
												{links &&
													links.map(
														(
															{
																to,
																label,
															}: {
																to?: string;
																label: string;
															},
															key: number
														) => {
															return (
																<li className={styles.item} key={key}>
																	<Link to={to} className={styles.link}>
																		{label}
																	</Link>
																</li>
															);
														}
													)}

												{subMenu.map(({ to, label, subMenu }, key: number) => {
													const ID = index;
													if (subMenu) index++;

													return subMenu ? (
														<li className={styles.item} key={key}>
															<button
																onClick={(e) => {
																	e.stopPropagation();
																	setSubMenuOpen((indexes) =>
																		subMenuOpen.includes(ID)
																			? indexes
																			: [...indexes, ID]
																	);
																}}
																className={styles.button}>
																{label}
																<ChevronRight className={styles.icon} />
															</button>

															<SubMenu
																heading={label}
																subMenuOpen={subMenuOpen}
																setSubMenuOpen={setSubMenuOpen}
																providedID={ID}>
																{subMenu.map(
																	(
																		{
																			to,
																			label,
																		}: {
																			to?: string;
																			label: string;
																		},
																		key: number
																	) => {
																		return (
																			<li className={styles.item} key={key}>
																				<Link to={to} className={styles.link}>
																					{label}
																				</Link>
																			</li>
																		);
																	}
																)}
															</SubMenu>
														</li>
													) : (
														<li className={styles.item} key={key}>
															<Link to={to} className={styles.link}>
																{label}
															</Link>
														</li>
													);
												})}
											</SubMenu>
										</li>
									) : (
										to && (
											<li className={styles.item} key={key}>
												<Link to={to} className={styles.link}>
													{label}
												</Link>
											</li>
										)
									);
								}
							)}

							{isGroup &&
								navigation &&
								navigation.map(({ label, globalNavigation }, key: number) => {
									const ID = index;
									index++;

									return globalNavigation ? (
										<li className={styles.item} key={key}>
											<button
												onClick={(e) => {
													e.stopPropagation();
													setSubMenuOpen((indexes) =>
														subMenuOpen.includes(ID)
															? indexes
															: [...indexes, ID]
													);
												}}
												className={styles.button}
												data-id={ID}>
												{label}
												<ChevronRight className={styles.icon} />
											</button>

											<SubMenu
												heading={label}
												subMenuOpen={subMenuOpen}
												setSubMenuOpen={setSubMenuOpen}
												providedID={ID}>
												{globalNavigation.map(
													(
														{
															to,
															label,
															menu,
														}: {
															to: string;
															label: string;
															menu: { label: string; menu: any }[];
														},
														key: number
													) => {
														const ID = index;
														if (menu) index++;

														return menu ? (
															<li className={styles.item} key={key}>
																<button
																	onClick={(e) => {
																		e.stopPropagation();
																		setSubMenuOpen((indexes) =>
																			subMenuOpen.includes(ID)
																				? indexes
																				: [...indexes, ID]
																		);
																	}}
																	className={styles.button}>
																	{label}
																	<ChevronRight className={styles.icon} />
																</button>

																<SubMenu
																	heading={label}
																	subMenuOpen={subMenuOpen}
																	setSubMenuOpen={setSubMenuOpen}
																	providedID={ID}>
																	{menu.map(
																		(
																			{
																				label,
																				menu,
																			}: {
																				label: string;
																				menu: {
																					label: string;
																					to: string;
																				}[];
																			},
																			key: number
																		) => {
																			return (
																				<li className={styles.item} key={key}>
																					<p className={styles.group}>
																						{label}
																					</p>

																					<ul>
																						{menu.map(
																							(
																								{
																									label,
																									to,
																								}: {
																									label: string;
																									to: string;
																								},
																								key: number
																							) => (
																								<li
																									className={styles.item}
																									key={key}>
																									<a
																										href={to}
																										className={styles.link}>
																										{label}
																									</a>
																								</li>
																							)
																						)}
																					</ul>
																				</li>
																			);
																		}
																	)}
																</SubMenu>
															</li>
														) : (
															<li className={styles.item} key={key}>
																<Link to={to} className={styles.link}>
																	{label}
																</Link>
															</li>
														);
													}
												)}
											</SubMenu>
										</li>
									) : null;
								})}
						</ul>
					</nav>
				)}

				{!isGroup && subNavigation && (
					<nav className={styles.navigation}>
						<ul className={cx(styles.list, styles.borderTop)}>
							{subNavigation.map(
								(
									{ label, to, globalNavigation }: INavigationItem,
									key: number
								) => {
									const ID = index;
									if (globalNavigation) index++;

									if (!careers && label === 'Careers') {
										return null;
									} else {
										return globalNavigation ? (
											<li className={styles.item} key={key}>
												<button
													onClick={(e) => {
														e.stopPropagation();
														setSubMenuOpen((indexes) =>
															subMenuOpen.includes(ID)
																? indexes
																: [...indexes, ID]
														);
													}}
													className={styles.button}
													data-id={ID}>
													{label}
													<ChevronRight className={styles.icon} />
												</button>

												<SubMenu
													heading={label}
													subMenuOpen={subMenuOpen}
													setSubMenuOpen={setSubMenuOpen}
													providedID={ID}>
													{globalNavigation.map(
														({ to, label, menu }, key: number) => {
															const ID = index;
															if (menu) index++;

															return menu ? (
																<li className={styles.item} key={key}>
																	<button
																		onClick={(e) => {
																			e.stopPropagation();
																			setSubMenuOpen((indexes) =>
																				subMenuOpen.includes(ID)
																					? indexes
																					: [...indexes, ID]
																			);
																		}}
																		className={styles.button}>
																		{label}
																		<ChevronRight className={styles.icon} />
																	</button>

																	<SubMenu
																		heading={label}
																		subMenuOpen={subMenuOpen}
																		setSubMenuOpen={setSubMenuOpen}
																		providedID={ID}>
																		{menu.map(
																			({ label, menu }, key: number) => {
																				return (
																					<li className={styles.item} key={key}>
																						<p className={styles.group}>
																							{label}
																						</p>

																						<ul>
																							{menu.map(
																								(
																									{
																										label,
																										to,
																									}: {
																										label: string;
																										to: string;
																									},
																									key: number
																								) => (
																									<li
																										className={styles.item}
																										key={key}>
																										<a
																											href={to}
																											target="_blank"
																											rel="nofollow"
																											className={styles.link}>
																											{label}
																										</a>
																									</li>
																								)
																							)}
																						</ul>
																					</li>
																				);
																			}
																		)}
																	</SubMenu>
																</li>
															) : (
																<li className={styles.item} key={key}>
																	<a
																		href={to}
																		target="_blank"
																		rel="nofollow"
																		className={styles.link}>
																		{label}
																	</a>
																</li>
															);
														}
													)}
												</SubMenu>
											</li>
										) : (
											<li key={key}>
												<a
													href={to}
													className={styles.link}
													aria-hidden={subMenuOpen ? 'false' : 'true'}
													tabIndex={subMenuOpen ? 0 : -1}>
													{label}
												</a>
											</li>
										);
									}
								}
							)}
						</ul>
					</nav>
				)}

				{/* Innotrans menu */}
				{isCampaign && (
					<nav className={styles.navigation}>
						<ul className={styles.list}>
							{innotransnav.map(
								(
									{ to, label, links, subMenu, globalNavigation },
									key: number
								) => {
									if (globalNavigation) return;

									return (
										<li className={styles.item} key={key}>
											<li className={styles.item} key={key}>
												<Link to={to} className={styles.link}>
													{label}
												</Link>
											</li>
											{subMenu?.map(({ to, label }, key: number) => {
												return (
													<li className={styles.item} key={key}>
														<Link to={to} className={styles.link}>
															{label}
														</Link>
													</li>
												);
											})}
											{links?.map(({ to, label }, key: number) => {
												return (
													<li className={styles.item} key={key}>
														<Link to={to} className={styles.link}>
															{label}
														</Link>
													</li>
												);
											})}
										</li>
									);
								}
							)}
						</ul>
					</nav>
				)}
				{/* End of Innotrans menu */}
			</div>
		</aside>
	);
};

export default MobileMenu;
